<ph-stack gap="tight">
    <ph-label *ngIf="!summary">{{ section.label }}</ph-label>
    <ph-alert status="success" variant="lighter" size="small">
        <div>{{ displayPrimary }}</div>
        <div *ngIf="displaySecondary">{{ displaySecondary }}</div>
    </ph-alert>
</ph-stack>
